import { Spin } from 'antd';
import s from './index.m.less';
const GrtLoading = ({top = 0}) => {
    return (
        <div className={s['box']} style={{marginTop: `${top}px`}}>
            <Spin />
        </div>
    );
};
export default GrtLoading;
